import { Chapter, CommunityFeed } from '@/types'
import { WebInputFile } from '@codeleap/common'
import { globalState } from '@codeleap/store'

type StoreValue = {
  type?: 'photo' | 'text' | 'video'
  file?: WebInputFile
  prompt?: CommunityFeed['prompt']
  lesson?: Chapter['id']
}

const SESSION_KEY = 'contribute_state'

const isSSR = typeof window === 'undefined' || typeof sessionStorage === 'undefined'

function readSession(): Partial<StoreValue> {
  if (isSSR) return {}
  try {
    const raw = sessionStorage.getItem(SESSION_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

function writeSession(value: Partial<StoreValue>) {
  if (isSSR) return
  try {
    const { type, prompt, lesson } = value
    sessionStorage.setItem(SESSION_KEY, JSON.stringify({ type, prompt, lesson }))
  } catch {}
}

export function clearSession() {
  if (isSSR) return
  try {
    sessionStorage.removeItem(SESSION_KEY)
  } catch {}
}

const persisted = readSession()

export const state = globalState<StoreValue>({
  type: null,
  file: null,
  prompt: null,
  lesson: null,
  ...persisted,
})

state.listen(value => {
  writeSession(value)
})
